import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// Service worker registration moved to SWUpdateBanner so we can react to
// `updatefound` events and prompt the user to reload on new deploys.
